import { JSX } from "react";
import { isAuthenticated } from "../auth";
import { env } from "../config/env";

interface Props {
  children: JSX.Element;
}

export default function ProtectedRoute({ children }: Props) {
  const authed = isAuthenticated();

  const apiBase = env.API_BASE_URL;

  if (!authed) {
    const redirectUrl = `${apiBase}auth/azure?app=mes`;
    window.location.href = redirectUrl;
    return null;
  }
  return children;
}
